import * as React from 'react';
import { Modal } from 'antd';
import WrappedRegistrationForm from './RegistrationForm/RegistrationForm';
import RegistrationModalLinks from './RegistrationModalLinks/RegistrationModalLinks';
import { Translate } from '@above-the-treeline/localization';
import './registrationModal.less';
import RegistrationDataStore from '../../../Registration/containers/RegistrationDataStore';

type RegistrationModalProps = {
	modalTitle: string;
	isVisible: boolean;
	setIsVisible: (isVisible: boolean) => void;
	type: string;
	setType: (type: string) => void;
};

export default function RegistrationModal({
	modalTitle,
	isVisible,
	setIsVisible,
	type,
	setType,
}: RegistrationModalProps) {
	const [isLoading, setIsLoading] = React.useState(false);

	return (
		<Modal
			title={<Translate id={modalTitle} />}
			destroyOnClose={true}
			visible={isVisible}
			onCancel={() => setIsVisible(false)}
			footer={null}
			wrapClassName="registration-modal">
			<RegistrationDataStore>
				<WrappedRegistrationForm
					type={type}
					isLoading={isLoading}
					setIsLoading={setIsLoading}
				/>
			</RegistrationDataStore>
			{!isLoading && (
				<RegistrationModalLinks setType={setType} type={type} />
			)}
		</Modal>
	);
}
